import apiClient from './client'

export interface UploadOptions {
  module?: string
  bizType?: string
  bizId?: string
}

export interface UploadItem {
  id: number
  createdAt: string
  updatedAt: string
  driver: string
  path: string
  url: string
  urlHash: string
  filename: string
  ext: string
  size: number
  mime: string
  hash: string
  module: string
  bizType: string
  bizId: string
  userId: number
  status: number
}

export interface UploadQuery {
  page: number
  pageSize: number
  keyword?: string
  module?: string
  driver?: string
  ext?: string
  userId?: number
  startAt?: string
  endAt?: string
}

export interface UploadStatItem {
  name: string
  count: number
  size: number
}

export interface UploadStats {
  totalCount: number
  totalSize: number
  modules: UploadStatItem[]
  drivers: UploadStatItem[]
}

export interface UploadDeleteResult {
  deleted: number
  failed: { id: number; msg: string }[]
}

/** 通用文件上传，复用 base 用户上传接口，返回文件访问地址 */
export const uploadFile = async (file: File, options: UploadOptions = {}): Promise<string> => {
  const form = new FormData()
  form.append('file', file)
  if (options.module) form.append('module', options.module)
  if (options.bizType) form.append('bizType', options.bizType)
  if (options.bizId) form.append('bizId', options.bizId)
  const resp = await apiClient.post('/api/user/upload/file', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return resp.data.data.url
}

// ── 管理端：上传文件登记 ──────────────────────────────────────────────────────
export const paginateUploads = async (params: UploadQuery) => {
  const res = await apiClient.post('/api/base/upload/paginate', params)
  return res.data.data as { records: UploadItem[]; total: number; page: number; pageSize: number }
}

export const getUploadStats = async (): Promise<UploadStats> => {
  const res = await apiClient.post('/api/base/upload/stats')
  return res.data.data
}

export const deleteUpload = async (id: number): Promise<void> => {
  await apiClient.post('/api/base/upload/delete', { id })
}

export const deleteUploadBatch = async (ids: number[]): Promise<UploadDeleteResult> => {
  const res = await apiClient.post('/api/base/upload/deleteBatch', { ids })
  return res.data.data
}
